import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Home from './pages/Home';
import AuthLayout from "./components/layout/AuthLayout"
import { Toaster } from "sonner";
import MainLayout from './components/layout/MainLayout';
import ProtectGuard from './components/layout/ProtectedGuard';
import Profile from './pages/Profile';
import CoursesPage from './pages/Courses';
import CourseDetailPage from './pages/CourseDetail';
import FileUpload from './pages/FileUpload';
import LessonPage from './pages/Lesson';
import TestsPage from './pages/Tests';
import DoTest from './pages/DoTest';

function App() {
  return (

    <Router>
      <Routes>


        <Route path="/login" element={<AuthLayout />}>
          <Route index element={<Login />}/>
        </Route>
        <Route path="/register" element={<AuthLayout />} >
          <Route index element={<Register />}/>
        </Route>

        <Route path="/" element={<MainLayout />} >
        <Route element={<ProtectGuard requireAuth={false}/>} >

          <Route index element={<Home />}/>
          <Route path='files' element={<FileUpload />}/>
          <Route path='courses' element={<CoursesPage />}/>
          <Route path='courses/:id' element={<CourseDetailPage />}/>


        </Route>
        <Route element={<ProtectGuard requireAuth={true}/>} >
          <Route path="profile" element={<Profile />}/>
          <Route path="courses/:course_id/lesson/:lesson_id" element={<LessonPage />}/>
          <Route path='courses/:id' element={<CourseDetailPage />}/>
          <Route path='courses/:course_id/test' element={<TestsPage />}/>
           <Route path='courses/:course_id/test/:test_id' element={<DoTest />}/>

        </Route>

        </Route>
      </Routes>
      <Toaster richColors position='bottom-right' />
    </Router>

  );
}

export default App;
